import * as React from "react";
import Button from "@mui/material/Button";
import Paper from "@mui/material/Paper";
import Slide from "@mui/material/Slide";
import Stack from "@mui/material/Stack";
import Typography from "@mui/material/Typography";

export interface SaveBarProps {
	count: number;
	saving: boolean;
	onSave: () => void;
	onDiscard: () => void;
}

// Sticky bar that slides in whenever any section has unsaved changes. One
// Save sends a single PUT with every changed key.
export function SaveBar({ count, saving, onSave, onDiscard }: SaveBarProps): React.JSX.Element {
	return (
		<Slide direction="up" in={count > 0} mountOnEnter unmountOnExit>
			<Paper
				elevation={8}
				sx={{
					border: "1px solid var(--mui-palette-divider)",
					borderRadius: 2,
					bottom: 16,
					position: "sticky",
					px: 2,
					py: 1.5,
					zIndex: "var(--mui-zIndex-appBar)",
				}}
			>
				<Stack direction="row" spacing={2} sx={{ alignItems: "center" }}>
					<Typography sx={{ flex: "1 1 auto" }} variant="subtitle2">
						{count} unsaved {count === 1 ? "change" : "changes"}
					</Typography>
					<Button color="secondary" disabled={saving} onClick={onDiscard} size="small">
						Discard
					</Button>
					<Button disabled={saving} onClick={onSave} size="small" variant="contained">
						{saving ? "Saving..." : "Save changes"}
					</Button>
				</Stack>
			</Paper>
		</Slide>
	);
}
